/**
 * !! WARNING !!
 * If in a next.js context, and you make use of this function, make sure to call it from a
 * useEffect, or a handler of some sort, as it access the document cookie.
 */
export var getGuidFromCookie = function getGuidFromCookie() {var _matchedGuid$;
  var matchedGuid = document.cookie.match(/guid=(([0-9a-fA-F-])+)/);

  return (_matchedGuid$ = matchedGuid === null || matchedGuid === void 0 ? void 0 : matchedGuid[1]) !== null && _matchedGuid$ !== void 0 ? _matchedGuid$ : '';
};
//# sourceMappingURL=getGuidFromCookie.js.map